var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type === _vm.ActivityTypes.USER_STATUS_CHANGED.id
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" local_cafe ")])
    : _vm.type === _vm.ActivityTypes.BLOCK_VISITOR.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v(" lock "),
      ])
    : _vm.type === _vm.ActivityTypes.UNBLOCK_VISITOR.id
    ? _c("span", { staticClass: "material-icons text-success" }, [
        _vm._v(" lock_open "),
      ])
    : _vm.type === _vm.ActivityTypes.USER_ADDED.id
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" person_add ")])
    : _vm.type === _vm.ActivityTypes.CHANNEL_CREATED.id
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" add_box ")])
    : _vm.type === _vm.ActivityTypes.CHANNEL_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.CHAT_OPENED.id
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" chat ")])
    : _vm.type === _vm.ActivityTypes.CHAT_CLOSED.id
    ? _c("span", { staticClass: "material-icons" }, [
        _vm._v(" mark_chat_read "),
      ])
    : _vm.type === _vm.ActivityTypes.WEBHOOK_ADDED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" webhook "),
      ])
    : _vm.type === _vm.ActivityTypes.WEBHOOK_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.TRIGGER_ADDED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.TRIGGER_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.TRIGGER_UPDATED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" update "),
      ])
    : _vm.type === _vm.ActivityTypes.DEPARTMENT_ADDED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.DEPARTMENT_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.ROLE_ADDED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.ROLE_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v(" remove_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.TAGS_ADDED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.TAGS_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v(" remove_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.WELCOME_MESSAGE_ADDED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.WELCOME_MESSAGE_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.BANNED_WORD_ADDED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.BANNED_WORD_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_WORKFLOW_CREATED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.SETTINGS_UPDATED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" settings "),
      ])
    : _vm.type === _vm.ActivityTypes.MAIL_ADDRESS_ADDED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.USER_ADDED_TO_DEPARTMENT.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" update "),
      ])
    : _vm.type === _vm.ActivityTypes.USER_REMOVED_FROM_DEPARTMENT.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.CHANNEL_VISIBILITY_CHANGED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v("\n    update\n"),
      ])
    : _vm.type === _vm.ActivityTypes.CONTENT_ADDED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.CONTENT_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.CUSTOMER_GROUP_ADDED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.CUSTOMER_GROUP_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.CUSTOMER_GROUP_UPDATED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" update "),
      ])
    : _vm.type === _vm.ActivityTypes.CHAT_ASSIGNED_TO_USER.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v(" maps_ugc "),
      ])
    : _vm.type === _vm.ActivityTypes.CHAT_FORWARDED_TO_USER.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v("\n    phone_forwarded\n"),
      ])
    : _vm.type === _vm.ActivityTypes.USER_JOINED_TO_CHAT.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v(" shortcut "),
      ])
    : _vm.type === _vm.ActivityTypes.USER_LOGGED_IN.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v(" login "),
      ])
    : _vm.type === _vm.ActivityTypes.TICKET_ASSIGNED_TO_USER.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v("\n    assignment_ind\n"),
      ])
    : _vm.type === _vm.ActivityTypes.WHATSAPP_BROADCAST_CREATED.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v("\n    cell_tower\n"),
      ])
    : _vm.type === _vm.ActivityTypes.WHATSAPP_BROADCAST_CANCELED.id
    ? _c("span", { staticClass: "material-icons text-warning" }, [
        _vm._v("\n    cell_tower\n"),
      ])
    : _vm.type === _vm.ActivityTypes.WHATSAPP_BROADCAST_COMPLETED.id
    ? _c("span", { staticClass: "material-icons text-success" }, [
        _vm._v("\n    cell_tower\n"),
      ])
    : _vm.type === _vm.ActivityTypes.WHATSAPP_BROADCAST_FAILED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v("\n    cell_tower\n"),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_WORKFLOW_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.BILLING_ADDRESS_UPDATED.id
    ? _c("span", { staticClass: "metarial-icons md-icon" }, [
        _vm._v(" update "),
      ])
    : _vm.type === _vm.ActivityTypes.INVOICE_CREATED.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v(" cell_tower "),
      ])
    : _vm.type === _vm.ActivityTypes.PLAN_STARTED.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v(" cell_tower "),
      ])
    : _vm.type === _vm.ActivityTypes.PLAN_CANCELED.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v(" cell_tower "),
      ])
    : _vm.type === _vm.ActivityTypes.INVOICE_PAYMENT_RECEIVED.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v(" paid "),
      ])
    : _vm.type === _vm.ActivityTypes.INVOICE_PAYMENT_FAILED.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v("\n    money_off_csred\n"),
      ])
    : _vm.type === _vm.ActivityTypes.PAYMENT_METHOD_ADDED.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v(" add_card "),
      ])
    : _vm.type === _vm.ActivityTypes.INVOICE_REFUNDED.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v("\n    assignment_return\n"),
      ])
    : _vm.type === _vm.ActivityTypes.LOGIN_FORM_ACTIVATED.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v("\n    format_indent_decrease\n"),
      ])
    : _vm.type === _vm.ActivityTypes.LOGIN_FORM_DEACTIVATED.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v("\n    format_indent_increase\n"),
      ])
    : _vm.type === _vm.ActivityTypes.LOGIN_FORM_UPDATED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" update "),
      ])
    : _vm.type === _vm.ActivityTypes.USER_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v(" remove_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.CONTACT_PROP_ADDED.id
    ? _c("span", { staticClass: "material-icons md-icon text-dark" }, [
        _vm._v("\n    add_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.CONTACT_PROP_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_CREATED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_STAGE_CHANGED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" update "),
      ])
    : _vm.type === _vm.ActivityTypes.WHATSAPP_CREDIT_LOW.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" expand_more "),
      ])
    : _vm.type === _vm.ActivityTypes.CHATBOT_CREATED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" smart_toy "),
      ])
    : _vm.type === _vm.ActivityTypes.CHATBOT_CREDIT_LOW.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" report "),
      ])
    : _vm.type === _vm.ActivityTypes.CHATBOT_CREDIT_DONE.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" disc_full "),
      ])
    : _vm.type === _vm.ActivityTypes.SYSTEM_STATUS.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" update "),
      ])
    : _vm.type === _vm.ActivityTypes.CHATBOT_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v(" remove_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.CHATBOT_PUBLISHED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" public "),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_ASSIGNED_TO_USER.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_task "),
      ])
    : _vm.type === _vm.ActivityTypes.WHATSAPP_V1_BOT_STATE_CHANGED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" qr_code_scanner "),
      ])
    : _vm.type === _vm.ActivityTypes.WHATSAPP_V2_BOT_STATE_CHANGED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" qr_code_scanner "),
      ])
    : _vm.type === _vm.ActivityTypes.RESERVATION_CREATED_PLAN.id
    ? _c("span", { staticClass: "metarial-icons md-icon" }, [_vm._v(" today ")])
    : _vm.type === _vm.ActivityTypes.RESERVATION_UPDATED_PLAN.id
    ? _c("span", { staticClass: "metarial-icons md-icon" }, [
        _vm._v(" event_repeat "),
      ])
    : _vm.type === _vm.ActivityTypes.RESERVATION_DELETED_PLAN.id
    ? _c("span", { staticClass: "metarial-icons md-icon" }, [
        _vm._v(" event_busy "),
      ])
    : _vm.type === _vm.ActivityTypes.RESERVATION_CREATED.id
    ? _c("span", { staticClass: "metarial-icons md-icon" }, [_vm._v(" today ")])
    : _vm.type === _vm.ActivityTypes.RESERVATION_UPDATED.id
    ? _c("span", { staticClass: "metarial-icons md-icon" }, [
        _vm._v(" event_repeat "),
      ])
    : _vm.type === _vm.ActivityTypes.RESERVATION_DELETED.id
    ? _c("span", { staticClass: "metarial-icons md-icon" }, [
        _vm._v(" event_busy "),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }